import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
} from 'intact';
import {XMarkdown} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', (
        _$cc(XMarkdown, {
            'content': this.get('content'),
            'codeBlockRenderers': this.getCodeBlockRenderers()
        })
    ), 2, 'xmarkdown-demo-code-block-renderers');
};